import { WixCodeApi } from '@wix/thunderbolt-symbols'

declare const self: DedicatedWorkerGlobalScope & { debugApi?: { wixCodeApi: WixCodeApi } }

export const initializeDebugApi = ({ wixCodeApi }: { wixCodeApi: WixCodeApi }) => {
	self.debugApi = {
		wixCodeApi,
	}
}
